module.exports = __webpack_public_path__ + "img/workContents01_pc_04.a59ae404.png";